<mat-card class="card" (click)="navigate()">
  <mat-card-content class="card__content">
    <div class="card__icon">
      @if (isMatIcon) {
        <mat-icon class="card__icon--border"
          ><span>{{ card.icon }}</span></mat-icon
        >
      }
      @if (isSvgIcon) {
        <mat-icon class="card__icon--svg" svgIcon="{{ card.icon }}"><span></span></mat-icon>
      }
    </div>
    <mat-card-title class="card__title">{{ card.header }}</mat-card-title>
    <mat-card-subtitle class="card__subtitle" [innerHTML]="card.description"></mat-card-subtitle>
  </mat-card-content>
  <mat-icon class="card__arrow"><span>east</span></mat-icon>
</mat-card>
